import { Icon, Menu, Popup, Table } from '@mairistem/composants';
import _ from 'lodash';

interface FactureRecuTableOptionsProps {
  produitsMontantsVisible: boolean;
  onProduitMontantsClick: () => void;
  resteEncaisserVisible?: boolean;
  onResteEncaisserClick?: () => void;
}
const FactureRecuTableOptions = ({
  produitsMontantsVisible,
  onProduitMontantsClick,
  resteEncaisserVisible,
  onResteEncaisserClick,
}: FactureRecuTableOptionsProps) => (
  <Popup
    style={{ padding: 0 }}
    trigger={
      <Table.HeaderCell style={{ width: 40 }}>
        <Icon link name="bars" data-testid="liste-bouton-actions" />
      </Table.HeaderCell>
    }
    position="bottom right"
    flowing
    on="focus"
    closeOnPortalMouseLeave
    content={
      <Menu vertical fluid borderless>
        <Menu.Item onClick={onProduitMontantsClick} data-testid="menu-item-produits-montants">
          {produitsMontantsVisible
            ? 'Masquer les produits et montants'
            : 'Afficher les produits et montants'}
          <Icon name={produitsMontantsVisible ? 'eye slash' : 'eye'} />
        </Menu.Item>
        {!_.isNil(onResteEncaisserClick) && (
          <Menu.Item onClick={onResteEncaisserClick} data-testid="menu-item-reste-encaisser">
            {resteEncaisserVisible
              ? 'Masquer le reste à encaisser'
              : 'Afficher le reste à encaisser'}
            <Icon name={resteEncaisserVisible ? 'eye slash' : 'eye'} />
          </Menu.Item>
        )}
      </Menu>
    }
  />
);

export default FactureRecuTableOptions;
